import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import React, { useState } from 'react';
import App from './App.tsx';

const Base = () => {
    const [themeMode] = useState<'light' | 'dark'>('light');
    const getTheme = (mode: 'light' | 'dark') => createTheme({
        palette: {
            mode,
            primary: {
                main: '#1565c0',
            },
            secondary: {
                main: '#2196f3',
            },
            background: {
                default: '#fff',
                paper: '#fff',
            },
            text: {
                primary: '#1a237e',
                secondary: '#2196f3',
            },
        },
        typography: {
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
        },
    });

    return (
        <ThemeProvider theme={getTheme('light')}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    );
};

export default Base;